import React, { MouseEventHandler, MutableRefObject, useEffect, useRef, useState } from "react";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import IconButton from "./IconButton";
import { useDispatch } from "react-redux";
import { setNoticeRegister } from "../../store/reducers/noticeReduce";
import { useAppSelector } from "../../store/actions/action";
import { NOTICE_ATTACH_GUIDE_MESSAGE } from "src/constants/notice";
import { pickNoticeAttachments } from "src/utils/noticeAttachSelection";

const FileUpload = () => {
  const fileInput = useRef<HTMLInputElement>(null);
  const noticeData = useAppSelector((state) => state.noticeReduce);
  const [fileList, setFileList] = useState<(File | Attachments)[]>(noticeData.fileList ? noticeData.fileList : []);
  const dispatch = useDispatch();

  useEffect(() => {
    noticeData.fileList && setFileList(noticeData.fileList);
  }, [noticeData.fileList]);

  useEffect(() => {
    dispatch(setNoticeRegister({ fileList: fileList }));
  }, [fileList]);

  const onClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files == null) return;
    const picked = pickNoticeAttachments(fileList.length, Array.from(e.target.files));
    if (!picked.ok) return alert(picked.message);
    setFileList((state) => [...state, ...picked.files]);
  };

  return (
    <FileUploadWrap>
      <dl>
        <dt>
          <p>파일첨부</p>
          <div>
            <label htmlFor="fileUploader">
              <SVG name="attach" width={13} height={13} viewBox="0 0 13 13" />
              파일선택
              <input id="fileUploader" type="file" multiple accept={"video/*,.zip,.pdf"} onChange={onClick} ref={fileInput} />
            </label>
          </div>
        </dt>
        <dd>{NOTICE_ATTACH_GUIDE_MESSAGE}</dd>
      </dl>
      <ul className="file-list">
        {fileList.map((file: File | Attachments, index: number) =>
          (file as File).name ? (
            <li key={index}>
              <p className="file-name">{(file as File).name}</p>
              <p className="file-size">{((file as File).size / 1000 ** 2).toFixed(2) + "MB"}</p>
              <IconButton btnName={(file as File).name} onClick={() => setFileList(fileList.filter((a) => a != file))}>
                <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
              </IconButton>
            </li>
          ) : (
            <li key={index}>
              <p className="file-name">{(file as Attachments).file_origin_name}</p>
              <IconButton btnName={(file as Attachments).file_origin_name} onClick={() => setFileList(fileList.filter((a) => a != file))}>
                <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
              </IconButton>
            </li>
          ),
        )}
        {/*{fileLoading && (*/}
        {/*  <li>*/}
        {/*    <p className="file-name"></p>*/}
        {/*    <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />*/}
        {/*  </li>*/}
        {/*)}*/}
      </ul>
    </FileUploadWrap>
  );
};

const FileUploadWrap = styled.div`
  /* padding: 14px 15px; */
  dt {
    ${({ theme }) => theme.flexBox.flexMixin("row", "space-between", "center")}
    > div {
      label {
        display: inline-block;
        width: auto;
        height: 28px;
        line-height: 26px;
        padding: 0 15px;
        border-radius: 20px;
        background-color: ${({ theme }) => theme.color.bgPrimary};
        color: ${({ theme }) => theme.color.secondary};
        font-size: 14px;
        > svg {
          position: relative;
          top: -2px;
          margin-right: 5px;
          vertical-align: text-bottom;
        }
      }
      input[type="file"] {
        ${/* 파일 필드 숨기기 */ ""}
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
      }
    }
  }
  dd {
    color: ${({ theme }) => theme.color.subMain};
    padding-left: 8px;
    text-indent: -8px;
    margin-top: 8px;
    font-size: 12px;
    line-height: 20px;
    word-break: keep-all;
  }
  .file-list {
    padding-top: 8px;
    > li {
      ${({ theme }) => theme.flexBox.flexMixin()}
      padding: 6px;
      margin-top: 8px;
      border: 1px solid ${({ theme }) => theme.color.linePrimary};
      color: ${({ theme }) => theme.color.tertiary};
      .file-name {
        flex-grow: 1;
        ${({ theme }) => theme.textOverflow.singleLine()}
      }
      .file-size {
        position: relative;
        flex-grow: 0;
        padding-left: 16px;
        margin-left: 16px;
        color: ${({ theme }) => theme.color.quaternary};
        &:before {
          position: absolute;
          left: 0;
          content: "";
          display: block;
          width: 2px;
          height: 16px;
          background-color: ${({ theme }) => theme.color.lineSecondary};
        }
      }
      button {
        flex-grow: 0;
        margin-left: 16px;
      }
    }
  }
`;

export default FileUpload;
